import type { JSX } from 'preact';
import type { ProductCard as ProductCardData } from '@sophia-ai/shared-types';

interface ProductCardProps {
  card: ProductCardData;
  onNotify: (title: string) => void;
  /** Fired when the customer clicks through to the product page (lead intent). */
  onView: () => void;
}

/** Short Arabic label for why this title surfaced (empty for a direct match). */
const REASON_LABEL: Record<ProductCardData['reason'], string> = {
  match: '',
  'same-author': 'لنفس المؤلف',
  'same-translator': 'لنفس المترجم',
  'same-publisher': 'لنفس الناشر',
  'same-genre': 'من النوع نفسه',
};

export function ProductCard({ card, onNotify, onView }: ProductCardProps): JSX.Element {
  const { product, reason } = card;
  const label = REASON_LABEL[reason];

  return (
    <article class="sa-card">
      {product.imageUrl !== null && (
        <img class="sa-card-cover" src={product.imageUrl} alt="" loading="lazy" />
      )}

      <div class="sa-card-body">
        <h4 class="sa-card-title" dir="auto">
          {product.name}
        </h4>

        {product.author !== null && (
          <span class="sa-card-author" dir="auto">
            {product.author.name}
          </span>
        )}

        {label !== '' && <span class="sa-card-reason">{label}</span>}

        <div class="sa-card-foot">
          {product.isBuyable ? (
            <>
              <span class="sa-price">
                {product.price.formatted} {product.price.currencySymbol}
              </span>
              <a
                class="sa-link"
                href={product.permalink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onView}
              >
                عرض الكتاب
              </a>
            </>
          ) : (
            <>
              <span class="sa-soldout">غير متوفر حالياً</span>
              <button type="button" class="sa-notify" onClick={() => onNotify(product.name)}>
                أعلِمني عند توفّره
              </button>
            </>
          )}
        </div>
      </div>
    </article>
  );
}
